// Mint-TMS-Routes · dữ liệu mẫu + logic thuần cho bảng Tuyến (TblTRFRoute rút gọn). Màn này không có số tiền.
// Mã tuyến/kho/điểm lấy-hạ chép từ script board; tên điểm tra ở bảng DP / WH bên dưới.

export type RouteStatus = 'ok' | 'pend' | 'off';
export type CargoGroup = 'RF' | 'DC';

export interface RouteRow {
  code: string;
  cg: CargoGroup;
  /** điểm lấy / hạ (mã cảng, ICD, depot) */
  from: string;
  /** kho khách (một hoặc nhiều) */
  warehouses: readonly string[];
  km: number;
  tier: string;
  status: RouteStatus;
  /** số trạm thu phí · số lượt qua trạm */
  tolls: number;
  passes: number;
  /** [TB, nhanh, chậm, số chuyến GPS] phút; null = chưa có chuyến GPS */
  gps: readonly [number, number, number, number] | null;
  /** ước tính VietMap (phút) khi chưa có GPS */
  est: number;
  trips: number;
  by: string;
  at: string;
  /** hạn giá TRF dd/Mon/yyyy ('' = chưa có) */
  priceTo: string;
}

export const TODAY = '22/Oct/2026';
export const TOTAL = 383;

/** điểm lấy / hạ · [mã, tên ngắn] */
export const DP: Readonly<Record<string, string>> = {
  VNCLI: 'Cát Lái', DP220010: 'TCIT Cái Mép', IPL3: 'ICD Phước Long 3', TNM: 'ICD Tanamexco', ITX: 'ICD Transimex', TCMT: 'Mỹ Thủy 1', DP220005: 'Phú Hưng Depot',
};
/** kho khách · [mã, tên, khách] */
export const WH: Readonly<Record<string, readonly [string, string]>> = {
  WH0002: ['Kho Ngọc Kim Loan', 'VJTrading BLIMEX DuyNhut NPFruit'], WH0004: ['Kho Thái Sơn', 'SEAPRO DSF2012 YuMi GREENBUD'], WH0020: ['Cây Xăng Thanh Phong', 'NDP HAINA HieuNam'],
  WH0041: ['Kho N&P, Bến Tre', 'NPFruit VJTrading'], WH0021: ['Kho Vinh Quang', 'NDP GREENBUD'], WH0040: ['Kho SFVN', 'SFVN'], WH0042: ['Kho Phú Quý Gia', ''], WH0164: ['Kho lạnh Hoàn Vũ', 'GREENBUD'],
  WH0046: ['Kho Tam Ngọc Cờ Đỏ', 'SEAPRO'], WH0051: ['Ba Sương - Hậu Giang', 'YuMi'], WH0026: ['Kho Thành Lợi', 'BLIMEX'], WH0022: ['Kho Khải Doanh (vỏ sò)', ''], WH0069: ['COCOGROUP', 'COCOGROUP'],
  WH0030: ['TRUNGPHAT', 'TRUNGPHAT'], WH0097: ['Savita - Kho Trạm biến điện', ''], WH0064: ['Kho Hoàng Lai (Sài Gòn)', 'HieuNam'], WH0223: ['CTY NIPPON RIKA', 'NIPPONRIKA'], WH0028: ['Ba Sương - Đồng Nai', 'YuMi'],
  WH0039: ['Kho lạnh Toàn Phát', 'HAINA'], WH0278: ['Kho VVP', ''], WH0170: ['Kho Khánh Đông', ''],
};
/** kho chưa có toạ độ (cảnh báo cạnh tên kho) */
export const WH_NO_XY: ReadonlySet<string> = new Set(['WH0021', 'WH0170']);
export const missingXY = (row: RouteRow): boolean => row.warehouses.some((c) => WH_NO_XY.has(c));

const r = (code: string, cg: CargoGroup, wh: string, from: string, km: number, tier: string, status: RouteStatus, tolls: number, passes: number, trips: number, by: string, at: string, priceTo: string, extra: readonly string[] = []): RouteRow =>
  ({ code, cg, from, warehouses: [wh, ...extra], km, tier, status, tolls, passes, trips, gps: GPS[code] ?? null, est: EST[code] ?? Math.round(km * 1.55), by, at, priceTo });

const GPS: Record<string, RouteRow['gps']> = {
  RRF0002: [515, 470, 610, 7], RRF0004: [545, 500, 640, 4], RRF0018: [290, 265, 330, 4], RRF0031: [345, 310, 395, 5], RRF0019: [150, 140, 160, 2], RRF0032: [95, 95, 95, 1], RRF0035: [55, 48, 70, 9],
  RRF0040: [300, 280, 350, 6], RRF0041: [375, 350, 420, 3], RRF0047: [140, 130, 160, 2], RDC0003: [330, 300, 385, 4], RDC0012: [52, 40, 75, 12], RDC0015: [95, 80, 120, 8], RDC0018: [130, 118, 150, 5],
  RDC0021: [110, 95, 140, 6], RDC0024: [185, 170, 215, 4], RDC0027: [190, 180, 205, 2], RDC0033: [205, 190, 230, 3], RDC0036: [160, 150, 180, 3], RDC0039: [85, 75, 100, 5],
};
const EST: Record<string, number> = { RRF0030: 55, RDC0010: 58, RRF0044: 290, RDC0029: 45 };

export const ROUTE_ROWS: readonly RouteRow[] = [
  r('RRF0002', 'RF', 'WH0002', 'VNCLI', 338.7, 'Tier4', 'ok', 4, 6, 7, 'PHONG', '21/Oct/2026 19:12', '15/Nov/2026'),
  r('RRF0004', 'RF', 'WH0004', 'VNCLI', 351, 'Tier4', 'ok', 4, 6, 5, 'THANH', '20/Oct/2026 22:05', '30/Oct/2026'),
  r('RRF0018', 'RF', 'WH0020', 'VNCLI', 178.8, 'Tier2', 'ok', 4, 6, 4, 'PHONG', '22/Oct/2026 09:40', '31/Dec/2026'),
  r('RRF0031', 'RF', 'WH0041', 'VNCLI', 216.7, 'Tier3', 'ok', 2, 4, 5, 'THANH', '19/Oct/2026 16:20', '31/Oct/2026'),
  r('RRF0019', 'RF', 'WH0021', 'VNCLI', 83, 'Tier2', 'pend', 0, 0, 2, 'THANH', '15/Oct/2026 11:05', ''),
  r('RRF0030', 'RF', 'WH0040', 'VNCLI', 32, 'Tier1', 'pend', 0, 0, 0, 'DAVID', '22/Oct/2026 08:10', ''),
  r('RRF0032', 'RF', 'WH0042', 'VNCLI', 50, 'Tier2', 'pend', 0, 0, 1, 'THANH', '22/Oct/2026 07:50', ''),
  r('RRF0035', 'RF', 'WH0164', 'TCMT', 21.4, 'Tier1', 'ok', 1, 1, 9, 'PHONG', '18/Oct/2026 10:30', '28/Oct/2026'),
  r('RRF0040', 'RF', 'WH0046', 'VNCLI', 186.2, 'Tier3', 'ok', 3, 4, 6, 'PHONG', '17/Oct/2026 14:05', '30/Nov/2026'),
  r('RRF0041', 'RF', 'WH0051', 'VNCLI', 232.5, 'Tier3', 'ok', 3, 4, 3, 'THANH', '16/Oct/2026 09:15', '30/Nov/2026'),
  r('RRF0044', 'RF', 'WH0026', 'IPL3', 172.9, 'Tier3', 'pend', 3, 4, 0, 'THANH', '21/Oct/2026 17:40', ''),
  r('RRF0047', 'RF', 'WH0164', 'DP220010', 72.6, 'Tier2', 'ok', 2, 3, 2, 'PHONG', '14/Oct/2026 08:20', '31/Dec/2026'),
  r('RDC0003', 'DC', 'WH0022', 'VNCLI', 194.2, 'Tier2', 'ok', 2, 4, 4, 'PHONG', '18/Oct/2026 20:30', '05/Nov/2026', ['WH0069']),
  r('RDC0010', 'DC', 'WH0030', 'VNCLI', 30.7, 'Tier1', 'ok', 0, 0, 0, 'PHONG', '12/Oct/2026 15:00', '31/Dec/2026'),
  r('RDC0012', 'DC', 'WH0064', 'VNCLI', 18.6, 'Tier1', 'ok', 1, 1, 12, 'THANH', '20/Oct/2026 11:25', '31/Dec/2026'),
  r('RDC0015', 'DC', 'WH0223', 'IPL3', 42.3, 'Tier1', 'ok', 1, 2, 8, 'THANH', '19/Oct/2026 09:00', '01/Nov/2026'),
  r('RDC0018', 'DC', 'WH0028', 'TNM', 61.8, 'Tier2', 'ok', 1, 2, 5, 'PHONG', '13/Oct/2026 16:45', '31/Dec/2026'),
  r('RDC0021', 'DC', 'WH0039', 'ITX', 52.4, 'Tier2', 'ok', 1, 2, 6, 'THANH', '11/Oct/2026 10:10', '31/Dec/2026'),
  r('RDC0024', 'DC', 'WH0069', 'VNCLI', 96.5, 'Tier2', 'ok', 2, 3, 4, 'PHONG', '10/Oct/2026 13:30', '31/Dec/2026'),
  r('RDC0027', 'DC', 'WH0278', 'VNCLI', 101.3, 'Tier2', 'off', 2, 3, 2, 'PHONG', '02/Oct/2026 09:00', ''),
  r('RDC0029', 'DC', 'WH0170', 'DP220005', 24, 'Tier1', 'pend', 0, 0, 0, 'DAVID', '22/Oct/2026 10:35', ''),
  r('RDC0033', 'DC', 'WH0097', 'VNCLI', 109, 'Tier3', 'pend', 0, 0, 3, 'THANH', '21/Oct/2026 14:15', ''),
  r('RDC0036', 'DC', 'WH0030', 'DP220010', 88.4, 'Tier2', 'ok', 1, 2, 3, 'PHONG', '09/Oct/2026 08:40', '31/Dec/2026'),
  r('RDC0039', 'DC', 'WH0042', 'TCMT', 38.5, 'Tier1', 'ok', 1, 2, 5, 'THANH', '20/Oct/2026 18:00', '29/Oct/2026'),
];

export const STATUS_LABEL: Record<RouteStatus, string> = { ok: 'Đã duyệt', pend: 'Chờ duyệt', off: 'Ngưng' };
export const CG_LABEL: Record<CargoGroup, string> = { RF: 'RF', DC: 'Khô' };
export const CG_TIP: Record<CargoGroup, string> = { RF: 'Hàng lạnh', DC: 'Hàng khô' };

const MON: Record<string, number> = { Jan: 1, Feb: 2, Mar: 3, Apr: 4, May: 5, Jun: 6, Jul: 7, Aug: 8, Sep: 9, Oct: 10, Nov: 11, Dec: 12 };
export function dayN(s: string): number | null {
  const m = /(\d{2})\/(\w{3})\/(\d{4})/.exec(s);
  return m && MON[m[2]!] ? Date.UTC(+m[3]!, MON[m[2]!]! - 1, +m[1]!) / 86400000 : null;
}

/** số ngày tới hạn giá TRF (null = chưa có hạn); sắp hết = 0..14 ngày. */
export function daysToExpiry(row: RouteRow, today = TODAY): number | null {
  const a = dayN(row.priceTo);
  const b = dayN(today);
  return a == null || b == null ? null : a - b;
}
export const expiring = (row: RouteRow): boolean => {
  const d = daysToExpiry(row);
  return d != null && d >= 0 && d <= 14;
};

/** "21/Oct/2026 19:12" → "21/Oct" */
export const shortDate = (s: string): string => s.split(' ')[0]!.replace('/2026', '');
export const fmtKm = (n: number): string => (Math.round(n * 10) / 10).toFixed(1).replace(/\.0$/, '').replace('.', ',');
export const fmtHM = (m: number): string => `${Math.floor(m / 60)}:${String(Math.round(m % 60)).padStart(2, '0')}`;
export const fmtFull = (m: number): string => `${Math.floor(m / 60)} giờ ${String(Math.round(m % 60)).padStart(2, '0')} phút`;

export const fromName = (row: RouteRow): string => DP[row.from] ?? row.from;
export const whName = (code: string): string => WH[code]?.[0] ?? code;
export const customersOf = (row: RouteRow): string[] => row.warehouses.flatMap((c) => (WH[c]?.[1] ?? '').split(' ')).filter(Boolean);

export interface RouteFilter {
  q: string;
  cg: 'all' | CargoGroup;
  from: readonly string[];
  wh: readonly string[];
  tier: readonly string[];
  status: readonly RouteStatus[];
  gps: readonly ('yes' | 'no')[];
  expiring: boolean;
}
export const EMPTY_FILTER: RouteFilter = { q: '', cg: 'all', from: [], wh: [], tier: [], status: [], gps: [], expiring: false };

type Skip = keyof RouteFilter | null;
/** Lọc; `skip` bỏ một chiều lọc để đếm số cạnh mỗi lựa chọn (như board). */
export function filterRoutes(rows: readonly RouteRow[], f: RouteFilter, skip: Skip = null): RouteRow[] {
  const ql = f.q.trim().toLowerCase();
  return rows.filter((x) => {
    if (skip !== 'cg' && f.cg !== 'all' && x.cg !== f.cg) return false;
    if (skip !== 'from' && f.from.length && !f.from.includes(x.from)) return false;
    if (skip !== 'wh' && f.wh.length && !f.wh.some((v) => x.warehouses.includes(v) || customersOf(x).includes(v))) return false;
    if (skip !== 'tier' && f.tier.length && !f.tier.includes(x.tier)) return false;
    if (skip !== 'status' && f.status.length && !f.status.includes(x.status)) return false;
    if (skip !== 'gps' && f.gps.length && !f.gps.includes(x.gps ? 'yes' : 'no')) return false;
    if (skip !== 'expiring' && f.expiring && !expiring(x)) return false;
    if (ql) {
      const hay = [x.code, x.cg, x.tier, x.from, fromName(x), ...x.warehouses, ...x.warehouses.map(whName), ...customersOf(x)].join(' ').toLowerCase();
      if (!hay.includes(ql)) return false;
    }
    return true;
  });
}

export interface RouteChips { pend: number; noGps: number; expiring: number }
export const routeChips = (rows: readonly RouteRow[]): RouteChips => ({
  pend: rows.filter((x) => x.status === 'pend').length,
  noGps: rows.filter((x) => !x.gps).length,
  expiring: rows.filter(expiring).length,
});

export const toggle = <T,>(arr: readonly T[], v: T): T[] => (arr.includes(v) ? arr.filter((x) => x !== v) : [...arr, v]);
